import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from 'lodash-es';
import {
  getConversationKnowledgeQuery,
  getConversationTopBarInfo,
  getRecentConsultingItem,
  ProductListParams,
  tradeList,
  TradeListParams,
} from 'services/api/conversation';
import { getTalkInfoByBuyerStore, GetTalkInfoByBuyerStoreBody } from 'services/api/refund';

export const conversations = createQueryKeys('conversations', {
  topbarInfo: (conversationId: string) => ({
    queryKey: [conversationId],
    queryFn: ({ signal }) => getConversationTopBarInfo({ conversationId }, signal),
  }),
  knowledgeQuery: (conversationId: string) => ({
    queryKey: [conversationId],
    queryFn: ({ signal }) => getConversationKnowledgeQuery(conversationId, signal),
  }),
  /**
   * 最近咨询的商品
   */
  inquiredProduct: (
    params: Pick<ProductListParams, 'internal_store_id' | 'internal_buyer_id'>,
  ) => ({
    queryKey: [params],
    queryFn: ({ signal }) =>
      getRecentConsultingItem(
        {
          ...params,
          page_no: 1,
          page_size: 1,
          needStockRule: false,
          ttsToko: false,
        },
        signal,
      ).then((res) => {
        const item = get(res, 'itemList[0]', undefined);
        return item || null;
      }),
  }),
  /**
   * 最近的订单
   */
  recentOrder: (
    params: Pick<TradeListParams, 'internal_store_id' | 'internal_buyer_id' | 'tunnelAccountId'>,
  ) => ({
    queryKey: [params],
    queryFn: async ({ signal }) => {
      const { internal_store_id, internal_buyer_id, tunnelAccountId } = params;
      return tradeList(
        {
          internal_buyer_id,
          internal_store_id,
          tunnelAccountId,
          page_no: 1,
          page_size: 1,
        } as TradeListParams,
        undefined,
        signal,
      ).then((res) => {
        return res.tradeList?.[0];
      });
    },
  }),
  detailByBuyerStore: (params: GetTalkInfoByBuyerStoreBody) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getTalkInfoByBuyerStore(params, signal),
  }),
});
